import React, { useEffect, useState, useRef } from "react";
import "../style/home.scss";
import HeaderBar from "./common/HeaderBar";
import { getCategoryList } from "../apis/GetProduct";
import PagePath from "../util/RoutePagePath";
import { routeToPage } from "../util/RouteToPage";
import { useNavigate } from "react-router-dom";
import FooterBar from "./common/FooterBar";

import { currency } from "./common/Common";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectFade, Autoplay, Pagination } from "swiper/modules";
import row1 from "../image/row1.webp";
import row1_1 from "../image/row1-1.webp";
import row2 from "../image/row2.webp";
import row2_1 from "../image/row2-1.webp";
import row2_2 from "../image/row2-2.webp";
import row2_3 from "../image/row2-3.webp";
import row3 from "../image/row3.webp";
import row4 from "../image/row4.webp";
import row4_1 from "../image/row4-1.webp";
import row5 from "../image/row5.webp";
import row6 from "../image/row6.webp";

const Home = () => {
  const [productList, setProductList] = useState([]);
  const navigate = useNavigate();

  const [position, setPosition] = useState(50);
  const [dragging, setDragging] = useState(false);
  const ref = useRef(null);

  const onMove = (e) => {
    if (!dragging) return;

    const rect = ref.current.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let percent = (x / rect.width) * 100;

    if (percent < 0) percent = 0;
    if (percent > 100) percent = 100;

    setPosition(percent);
  };

  useEffect(() => {
    let list1 = getCategoryList("Bobi");
    let list2 = getCategoryList("Léon");
    let list3 = getCategoryList("Lulu");
    setProductList([list1, list2, list3]);
  }, []);

  // 鼠标悬停切换图片
  const handleHover = (listIndex, itemIndex, ishover) => {
    setProductList((prev) =>
      prev.map((list, lIdx) =>
        lIdx === listIndex
          ? {
              ...list,
              list: list.list.map((item, iIdx) =>
                iIdx === itemIndex ? { ...item, ishover } : item,
              ),
            }
          : list,
      ),
    );
  };
  return (
    <React.Fragment>
      <HeaderBar />
      <div>
        <div className="relative grid grid-cols-2">
          <div>
            <img src={row1} alt="" />
          </div>
          <div>
            <img src={row1_1} alt="" />
          </div>
          <div className="h-fll absolute inset-0 z-10 flex w-full flex-col items-center justify-center bg-black/10 text-white">
            <p className="text-[50px] font-bold">Leather Essentials</p>
            <p>Bags and accessories for the long haul.</p>
          </div>
        </div>

        {/* product */}
        <div className="mx-auto my-section">
          {productList?.map((item, listIndex) => (
            <React.Fragment>
              <div key={listIndex}>
                {/* <div className="font-500 mx-auto mb-2 text-center text-[24px] uppercase tracking-[5px]">
                  {item?.category}
                </div> */}
                <div className="mx-auto grid cursor-pointer grid-cols-1 gap-10 gap-y-20 p-10 text-center sm:grid-cols-2 lg:grid-cols-4">
                  {item?.list?.map((i, itemIndex) => (
                    <div
                      key={itemIndex}
                      onMouseEnter={() =>
                        handleHover(listIndex, itemIndex, true)
                      }
                      onMouseLeave={() =>
                        handleHover(listIndex, itemIndex, false)
                      }
                      onClick={() =>
                        routeToPage(
                          navigate,
                          `${PagePath.PRODUCTDETAIL_PAGE}/${i.id}`,
                        )
                      }
                    >
                      <div className="bg-grey mb-2 overflow-hidden rounded-md">
                        <img
                          src={
                            i.ishover ? (i.image[1] ?? i.image[0]) : i.image[0]
                          }
                          alt=""
                          className="object-cover"
                        />
                      </div>
                      <div className="my-4 text-[16px]">
                        {i.title} {i.title1}
                      </div>
                      <div className="text-[14px] font-bold text-price">
                        {currency}
                        {i.price?.toLocaleString()}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>

        <div className="my-10 grid grid-cols-2 gap-10 p-20">
          <div className="aspect-[3/2] overflow-hidden rounded-md">
            <img
              src={row2}
              alt=""
              className="transition-transform duration-500 ease-out hover:scale-105"
            />
          </div>
          <div className="flex flex-col items-center justify-center rounded-md bg-[#f2f1e6]">
            <p>NEW RELEASE</p>
            <p className="text-[50px] font-bold">Cowhide Grumpy Slipper</p>
          </div>
          <div className="aspect-[3/2] overflow-hidden rounded-md">
            <img
              src={row2_1}
              alt=""
              className="transition-transform duration-500 ease-out hover:scale-105"
            />
          </div>
          <div className="aspect-[3/2] overflow-hidden rounded-md">
            <img
              src={row2_2}
              alt=""
              className="transition-transform duration-500 ease-out hover:scale-105"
            />
          </div>
          <div className="aspect-[3/2] overflow-hidden rounded-md">
            <img
              src={row2_3}
              alt=""
              className="transition-transform duration-500 ease-out hover:scale-105"
            />
          </div>
          <div className="flex flex-col items-center justify-center rounded-md bg-[#f2f1e6] px-40 text-center">
            <p>Let’s Get</p>
            <p className="text-[50px] font-bold">Personalized</p>
            <p className="text-[14px] leading-8">
              From incorporating your logo or custom text into one of our
              handcrafted products to a fully bespoke design that meets your
              exact needs, we create gifts that let your team know they are
              appreciated. Email us at sales@wpstandard.com to get started.
            </p>
          </div>
        </div>
        <div className="relative my-section h-[600px]">
          <img src={row3} alt="" />
          <div className="h-fll absolute inset-0 z-10 flex w-full flex-col justify-end bg-black/10 p-20 text-white">
            <p className="text-[50px] font-bold">Leather Essentials</p>
            <p>Bags and accessories for the long haul.</p>
          </div>
        </div>
        <div className="my-10 grid grid-cols-2 gap-10 p-20">
          {" "}
          <div className="flex flex-col items-center justify-center rounded-md bg-[#f2f1e6] px-40 text-center">
            <p>HISTORY PRESERVED</p>
            <p className="text-[50px] font-bold">
              (RE)MAKING OF A VIETNAM-ERA DUFFLE
            </p>
          </div>
          <div className="aspect-[3/2] overflow-hidden rounded-md">
            <img
              src={row4}
              alt=""
              className="transition-transform duration-500 ease-out hover:scale-105"
            />
          </div>
        </div>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Home;
